import React from 'react'
import Header from '../layout/header'
import Dashboard from '../sidebar/dashboard'

export default function Home() {
  return (
   <div className=''>
        <Header/>
        <Dashboard/>
      </div>
      
  )
}
